module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/api-24484816aff369b55b7f9b0d73e307df.png";